import { useRouter } from 'next/router'

import ArtistInfo from '../../../../components/artist-info'
import ViewTracker from '../../../../components/tracking/view-tracker'
import { ArtistEl } from '../elements'
import CourseHomeStore from '../stores/course-home-store'

const Artist = () => {
  const { asPath } = useRouter()
  const {
    query: { livdemyId },
  } = useRouter()

  const {
    data: { coHosts = [] },
  } = CourseHomeStore.useContainer()

  return (
    <ArtistEl>
      <ViewTracker item='artist info' page={asPath} />
      <ArtistInfo livdemyId={livdemyId} />
      {coHosts.map((coHost) => (
        <ArtistInfo key={coHost.livdemyId} livdemyId={coHost.livdemyId} />
      ))}
    </ArtistEl>
  )
}

export default Artist
